import { store } from '../../../configuration/setup/store';
import { updateWidgetId } from '../widgetSlice';

export const SET_WIDGET_ID_EVENT = 'EVENT_SET_WIDGET_ID';

export const setWidgetIdHandler = (data: string) => {
    store.dispatch(updateWidgetId(data));
};
